import { SocialPlatformType } from '@stereoagency/ui';

const platformFromURL = (url: string): SocialPlatformType => {
  if (url.match(/facebook\.com/)) return 'fb';
  if (url.match(/twitter\.com/)) return 'tw';
  if (url.match(/linkedin\.com/)) return 'lin';
  if (url.match(/youtube\.com/)) return 'yt';
  if (url.match(/flickr\.com/)) return 'flckr';
  if (url.match(/instagram\.com/)) return 'insta';
  return 'none';
};

export default platformFromURL;
